import { axiosInstance } from 'src/store/server/client';
import type { APICommonResponse } from 'src/types/common.types';
import { checkLogin } from 'src/utils/auth';

import type { GetMainEventListResponse, GetMainOriginalsListResponse, SetOriginalsFavorRequest } from './main.dto';

export const mainService = {
  // 메인 이벤트 목록 조회
  getMainEventList: async (): Promise<APICommonResponse<GetMainEventListResponse>> => {
    return axiosInstance.market.public.get('/main/event');
  },

  // 메인 오리지널스 목록 조회
  getMainOriginalsList: async (): Promise<APICommonResponse<GetMainOriginalsListResponse>> => {
    return (checkLogin() ? axiosInstance.market.private : axiosInstance.market.public).get('/main/originals');
  },

  // 오리지널스 좋아요
  setOriginalsFavor: async (params: SetOriginalsFavorRequest): Promise<APICommonResponse<null>> => {
    return axiosInstance.market.private.post('/main/originals/favor', params);
  },
};
